import { render, staticRenderFns } from "./SleepMattressDetail.vue?vue&type=template&id=b2eb8e40&scoped=true"
import script from "./SleepMattressDetail.vue?vue&type=script&lang=js"
export * from "./SleepMattressDetail.vue?vue&type=script&lang=js"
import style0 from "./SleepMattressDetail.vue?vue&type=style&index=0&id=b2eb8e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eb8e40",
  null
  
)

export default component.exports